import { render, staticRenderFns } from "./AgentsCrudPage.vue?vue&type=template&id=989a66d2"
import script from "./AgentsCrudPage.vue?vue&type=script&lang=js"
export * from "./AgentsCrudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports